//import $ from 'jquery';
import DOMHelpers from '../utils/dom-helpers';
// import { debounce as _debounce } from 'es-toolkit';
import { gsap } from 'gsap';



export default class {

	constructor(options) {

		// OPTIONS
		this.defaults = {
		}

		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = 'contact-form-module';

		// DOM ELEMENT !!!!!!!!!!
		this.el = this.options.el;
        this.main = this.options.main;

		// DOM helpers
		this.dom = new DOMHelpers(document);

		// VARS (vanilla DOM)
		this.window = window;
		this.document = document;
		this.htmlEl = document.documentElement;
		this.body = document.body;

        this.form = this.el.querySelector( 'form' );
        this.formOutput = this.form.querySelector( '.wpcf7-response-output' );
        this.response = this.el.querySelector( '.response' );
        this.responseContent = this.response.querySelector( '.text' );


		// init!!!!
		this.init(true);

	}

	init(b) {
		this.addEvents(b);
	}

	addEvents(b) {
        this.ajaxifyForm(b);
        this.initContactFormEvents(b);
        this.initResponse(b);
		//this.attachEventsKeyBoard(b);
    }

    ajaxifyForm( b ){
        if ( b ){
            if (window.wpcf7 && typeof window.wpcf7.init === 'function' && this.form ) {
                window.wpcf7.init(this.form);
            }
        }
    }

    initContactFormEvents( b ){
        const   wpcf7Elm = this.el.querySelector( '.wpcf7' ),
                submit = this.form.querySelector( '.wpcf7-submit' ) ;
        
        if ( b ){
            this.dom.on( submit, 'click', this.onClickSubmit );
            wpcf7Elm.addEventListener( 'wpcf7submit', this.onSubmit );
            this.form.addEventListener( 'change', this.onChangeForm );
        }
        else{
            this.dom.off( submit, 'click', this.onClickSubmit );
            wpcf7Elm.removeEventListener( 'wpcf7submit',  this.onSubmit );
            this.form.removeEventListener( 'change', this.onChangeForm );
        }

    }

    onClickSubmit = () => {
        this.setLoading(true);
    }

    onSubmit = (e) => {
        this.setLoading( false );
        this.openResponse( true, e.detail.apiResponse.message );
    }

    onChangeForm = (e) => {
        const input =  e.target;
        if ( input.classList.contains( 'wpcf7-not-valid' ) ){
            input.classList.remove( 'wpcf7-not-valid' );
        }
    }

    setLoading( b ){
        this.options.main.setLoading( b );
        if ( b ){
            gsap.to( this.form, {opacity:0.4, ease: 'circ.out', duration:0.4 } );
        }
    }
    
    //---------------------------------------------------------[ RESPONSE WINDOW ]---------------------------------------------------------//

    initResponse( b ){
        const close = this.response.querySelector( '.close' );
        if ( b ){
            // close when clicked outside the window
            this.document.addEventListener( 'click', this.onClickDocument );

            // close trough the win close svg
            close.addEventListener( 'click', this.onCloseClick );
        }
        else{
            this.document.addEventListener( 'click', this.onClickDocument );

            close.removeEventListener( 'click', this.onCloseClick );
        }
    }

    onCloseClick = (e)=>{
        e.preventDefault();
        this.openResponse( false );
    }

    onClickDocument = (e) => {
        if ( this.dom.parents( e.target, '.win' ).length === 0 ){
            if ( this.dom.hasClass( this.response, 'open' ) ){
                this.openResponse( false );
            }
        }         
    }

    openResponse( b, message=false){
        if ( b ){
            if ( message ){
                this.responseContent.textContent = message;
            }
            this.dom.addClass( this.response, 'open' );
        }
        else{
            this.dom.removeClass( this.response, 'open' );
            gsap.to( this.form, {opacity:1, ease: 'circ.out', duration:0.4 } );
        }
    }


	// public methods //////////////////////////////////////////////////////////////////////////
	destroy() {
		this.init(false);
	}

}
